<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" class="filter-item" type="primary" @click="weekview" plain>周末留宿一览</el-button>
      </template>
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="success" @click="change('pass')">通过</el-button>
        <el-button size="mini" class="filter-item" type="warning" @click="change('back')">不通过</el-button>
        <el-button size="mini" class="filter-item" type="info" @click="change('cancel')">取消</el-button>
        <el-button size="mini" class="filter-item" type="primary" @click="create" icon="el-icon-plus" title="班主任可不受留宿报名时间限制添加留宿报名，自动处于已审核通过状态">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="change('delete')" v-if="$permission.can('删除')">删除</el-button>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <week-dialog ref="weekDialog" @close-saved="reload"></week-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/attendance/approval/list";
import editDialog from "@/components/attendance/approval/editDialog";
import weekDialog from "@/components/attendance/approval/weekDialog";

export default {
  name: "approval",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    weekDialog
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    weekview() {
      this.$refs.weekDialog.openDetails();
    },
    change(type) {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要操作的数据");
        return;
      }
      this.$confirm("确认操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.StayRegId;
          });
          this.$refs.list.change(ids,type);
        })
        .catch(() => {});
    },
  },
};
</script>